class ColorToggle {
  constructor() {
    this.colorInputToImageMap = new Map();
    this.inputToProductInfoMap = new Map(); // Stores { productId, section }
    
    this.productColorImageMaps = {
      // revamp test product 
      "8620831473820":{
        top: {
          "Black": "https://cdn.shopify.com/s/files/1/0697/8745/1548/files/blacktopicon.png?v=1762931006",
          "Navy": "https://cdn.shopify.com/s/files/1/0697/8745/1548/files/navytop.png?v=1762930991",
          "Light Blue": "https://cdn.shopify.com/s/files/1/0697/8745/1548/files/lightbluetopicon.png",
        },
        bottom: {
          "Black": "https://cdn.shopify.com/s/files/1/0697/8745/1548/files/blackpanticon.png?v=1762931061",
          "Navy": "https://cdn.shopify.com/s/files/1/0697/8745/1548/files/navypanticon.png?v=1762931047",
          "Light Blue": "https://cdn.shopify.com/s/files/1/0697/8745/1548/files/lightbluepanticon.png?v=1762937593",
        }
      },
      // men's comfortlayer scrub set v2
      "8646302400668":{
        top: {
          "Black": "https://cdn.shopify.com/s/files/1/0697/8745/1548/files/blacktopicon.png?v=1762931006",
          "Navy": "https://cdn.shopify.com/s/files/1/0697/8745/1548/files/navytop.png?v=1762930991",
          "Light Blue": "https://cdn.shopify.com/s/files/1/0697/8745/1548/files/lightbluetopicon.png",
        },
        bottom: {
          "Black": "https://cdn.shopify.com/s/files/1/0697/8745/1548/files/blackpanticon.png?v=1762931061",
          "Navy": "https://cdn.shopify.com/s/files/1/0697/8745/1548/files/navypanticon.png?v=1762931047",
          "Light Blue": "https://cdn.shopify.com/s/files/1/0697/8745/1548/files/lightbluepanticon.png?v=1762937593",
        }
      },
      // women's comfortlayer scrub set v2
      "8646401294492":{
        top: {
          "Black": "https://cdn.shopify.com/s/files/1/0697/8745/1548/files/1.png?v=1763549913",
          "Navy": "https://cdn.shopify.com/s/files/1/0697/8745/1548/files/2_a698c448-6d44-4a63-bfc0-a91e594b9e44.png?v=1763549913",
          "Light Blue": "https://cdn.shopify.com/s/files/1/0697/8745/1548/files/3_9f1dcf75-663d-4628-99d2-4857822b2536.png?v=1763549913",
        },
        bottom: {
          "Black": "https://cdn.shopify.com/s/files/1/0697/8745/1548/files/blackpanticon.png?v=1762931061",
          "Navy": "https://cdn.shopify.com/s/files/1/0697/8745/1548/files/navypanticon.png?v=1762931047",
          "Light Blue": "https://cdn.shopify.com/s/files/1/0697/8745/1548/files/lightbluepanticon.png?v=1762937593",
        }
      },
      "8555121541276": {
        top: {
          "Black": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_5_31PM_1.jpg",
          "Navy": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_5_20PM.jpg",
          "Light Blue": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_5_38PM_1.jpg",
        },
        bottom: {
          "Black": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_5_31PM.jpg",
          "Navy": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_5_22PM.jpg",
          "Light Blue": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_5_38PM.jpg",
        }
      },

      // men comfortlayer scrub set
      "8556007030940": {
        top: {
          "Black": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_5_31PM_1.jpg",
          "Navy": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_5_20PM.jpg",
          "Light Blue": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_5_38PM_1.jpg",
        },
        bottom: {
          "Black": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_5_31PM.jpg",
          "Navy": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_5_22PM.jpg",
          "Light Blue": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_5_38PM.jpg",
        }
      },

      // women comfortlayer scrub set
      "8556009128092": {
        top: {
          "Black": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_5_05PM.jpg",
          "Navy": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_5_08PM_7.jpg",
          "Light Blue": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_5_12PM.jpg",
        },
        bottom: {
          "Black": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_5_06PM.jpg",
          "Navy": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_5_08PM_6.jpg",
          "Light Blue": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_5_08PM_2_1.jpg",
        }
      },
      // women Activelayer scrub set
      "8579764060316": {
        top: {
          "Black": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_5_05PM.jpg",
          "Navy": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_5_08PM_7.jpg",
          "Light Blue": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_5_12PM.jpg",
          "Wine": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_3_27PM_2_c9c5a4b5-8e57-4366-a79b-46833f773a15.jpg"
        },
        bottom: {
          "Black": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_5_06PM.jpg",
          "Navy": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_5_08PM_6.jpg?v=1761203597",
          "Light Blue": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_5_08PM_2_1.jpg?v=1761203597",
          "Wine": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_3_27PM_1_23430e03-ef9d-4475-87d7-e0419a17c32f.jpg?v=1761203597"
        }
      },

      // men Activelayer scrub set
      "8579877535900": {
        top: {
          "Black": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_5_31PM_1.jpg?v=1761216764",
          "Navy": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_5_20PM.jpg?v=1761216764",
          "Light Blue": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_5_38PM_1.jpg?v=1761216764",
          "Wine": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_5_17PM_1_254c62e8-2754-4dc0-b931-3bf40f1a5262.jpg?v=1761216764"
        },
        bottom: {
          "Black": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_5_31PM.jpg?v=1758780211",
          "Navy": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_5_22PM.jpg?v=1758801526",
          "Light Blue": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_5_38PM_d71f4c1a-7523-4b87-91ee-7482038391eb.jpg?v=1759761608",
          "Wine": "https://thefourthlayer.in/cdn/shop/files/Generated_Image_September_02_2025_-_5_17PM_19076d11-99a5-4193-b642-f5d883ab7d84.jpg?v=1761216764"
        }
      }

      

    };
    
    this.init();
  }

  init() {
    const images = document.querySelectorAll('.product-image img, .product-image-new img');
    const colorGroups = Array.from(document.querySelectorAll('.tcustomizer-field--RadioColor'));

    colorGroups.forEach((group, index) => {
      // Extract productId from class pattern
      const productIdMatch = Array.from(group.classList)
        .find(cls => /\d{10,}/.test(cls));
      const productId = productIdMatch ? productIdMatch.split('-').pop() : null;

      // Determine section name by index
      const section = index === 0 ? 'top' : 'bottom';

      const inputs = group.querySelectorAll('.tcustomizer__btn-check');
      
      inputs.forEach(input => {
        const imageElement = images[index] || images[0];
        this.colorInputToImageMap.set(input, imageElement);
        this.inputToProductInfoMap.set(input, {productId, section});
        input.addEventListener('click', e => this.handleColorChange(e));
      });
    });
  }

  handleColorChange(event) {
    const input = event.target;
    const selectedColor = input.value;
    const imageElement = this.colorInputToImageMap.get(input);
    if (!imageElement) return;

    const productInfo = this.inputToProductInfoMap.get(input);
    if (!productInfo) return;

    const {productId, section} = productInfo;

    const productMap = this.productColorImageMaps[productId] || {};
    const colorMap = productMap[section] || {};

    const newSrc = colorMap[selectedColor] || imageElement.src;

    imageElement.src = newSrc;
  }
}

document.addEventListener('DOMContentLoaded', () => new ColorToggle());

window.onload = () => {
  const productIDs = [
    "8556007030940", // Men
    "8556009128092", // Women
    "8579764060316", // Women Activlayer Scrub Set
    "8579877535900",  // Men Activlayer Scrub Set
    "8620831473820",
    "8646302400668", // men's comfortlayer scrub set v2
    "8646401294492" // women's comfortlayer scrub set v2
  ];

  // Check if the product ID on the page matches one of the above
  const productInput = document.querySelector('input[type="hidden"][name="product-id"]');
  if (productInput && productIDs.includes(productInput.value)) {
    // Hide Shiprocket elements
    document.querySelectorAll('.shiprocket-headless').forEach(el => {
      el.style.display = 'none';
    });

    // Change Add to Cart button color only for these products
    const button = document.querySelector(".tcustomizer-overlap-button");
    if (button) {
      button.style.backgroundColor = "#0a0a23";
      button.style.color = "#ffffff";
      button.style.transition = "background-color 0.3s ease, color 0.3s ease";

      button.addEventListener("mouseenter", () => {
        button.style.backgroundColor = "#0a0a23";
      });

      button.addEventListener("mouseleave", () => {
        button.style.backgroundColor = "#0a0a23";
      });
    }
  }
};


// move add on message
const observer = new MutationObserver(() => {
  const groupPopup = document.querySelector('.tcustomizer-group-popup');
  if (groupPopup) {
    document.querySelectorAll('.tcustomizer-price-addons').forEach(span => {
      if (span.parentNode !== groupPopup.parentNode || span.previousSibling !== groupPopup) {
        groupPopup.parentNode.insertBefore(span, groupPopup.nextSibling);
      }
    });
  }
});

// Utility function to insert the success message if needed
function insertSuccessMessage(customizerData) {
  
  var printInput = customizerData.querySelector('input[type="hidden"][name="properties[Print]"]');
  if (printInput) {

    var groupPopupDiv = document.querySelector('.tcustomizer-group-popup');
    if (groupPopupDiv && !document.querySelector('.customization-success-msg')) {
      var successMsg = document.createElement('div');
      successMsg.textContent = "Customization added successfully";
      successMsg.className = "customization-success-msg";
      groupPopupDiv.parentNode.insertBefore(successMsg, groupPopupDiv.nextSibling);
    }
  } else {
    var existingMsg = document.querySelector('.customization-success-msg');
    if (existingMsg) {
      existingMsg.remove();
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  var customizerData = document.querySelector('.tcustomizer-data');
  if (!customizerData) return;

  // Initial check
  insertSuccessMessage(customizerData);

  // Observe mutations to .tcustomizer-data only
  var observer = new MutationObserver(function () {
    insertSuccessMessage(customizerData);
  });

  observer.observe(customizerData, {
    childList: true,
    subtree: true,
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});


// document.addEventListener('DOMContentLoaded', function() {
//   var label = Array.from(document.querySelectorAll('.tcustomizer-group-popup__activator'))
//     .find(el => el.textContent.includes('Custom Print'));
//   if (label) {
//     label.style.fontWeight = '700';
//     label.style.color = '#178963';
//     label.style.transition = 'color 0.5s';

//     // Add pulse animation via inline style
//     label.style.position = 'relative';
//     label.style.zIndex = '1';
//     label.animate([
//       { boxShadow: '0 0 0px 0px #34d399', color: '#178963' },
//       { boxShadow: '0 0 10px 3px #a7f3d0', color: '#065f46' },
//       { boxShadow: '0 0 0px 0px #34d399', color: '#178963' }
//     ], {
//       duration: 1400,
//       iterations: 2
//     });

//     // Optional: on hover, animate color
//     label.addEventListener('mouseenter', function() {
//       label.style.color = '#065f46';
//     });
//     label.addEventListener('mouseleave', function() {
//       label.style.color = '#178963';
//     });
//   }
// });


function animateCustomPrintActivator(label) {
  label.classList.add('tcustomizer-group-popup__activator'); // Ensure class is set
  label.style.animation = 'customPrintPopupFade 1.3s cubic-bezier(0.65, 0.05, 0.36, 1) 1';
  // Remove animation property after animation ends for hover effect to work naturally
  label.addEventListener('animationend', function() {
    label.style.animation = '';
  }, { once: true });
}

// Use IntersectionObserver for entrance animation when element is visible
document.addEventListener('DOMContentLoaded', function() {
  var labels = Array.from(document.querySelectorAll('.tcustomizer-group-popup__activator'))
    .filter(el => el.textContent.includes('Custom Print'));
  labels.forEach(function(label) {
    // Observer triggers when label is in viewport
    var observer = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting) {
        animateCustomPrintActivator(label);
        observer.disconnect();
      }
    }, { threshold: 0.6 });
    observer.observe(label);

    // Retain hover effect
    label.addEventListener('mouseenter', function() {
      label.style.color = '#065f46';
    });
    label.addEventListener('mouseleave', function() {
      label.style.color = '#178963';
    });
  });
});


